"use client";

import React, { useState, useEffect } from "react";
import { useRouter } from "next/navigation";
import ComingSoonModal from "@components/modals/coming-soon-modal";

const CertificatePage: React.FC = () => {
	const [modalOpen, setModalOpen] = useState(false);
	const router = useRouter();

	useEffect(() => {
		setModalOpen(true);
	}, []);

	const handleCloseModal = () => {
		setModalOpen(false);
		router.push("/");
	};

	return (
		<>
			<div className="flex items-center justify-center min-h-screen">
				<div className="text-center">
					<h1 className="text-xl font-semibold mb-4">Tính năng Chứng chỉ</h1>
					<p className="text-gray-600 mb-4">
						Tính năng này sẽ có sẵn trong thời gian sớm nhất.
					</p>
				</div>
			</div>

			<ComingSoonModal open={modalOpen} onClose={handleCloseModal} />
		</>
	);
};

export default CertificatePage;
